export default "__VITE_ASSET__Dp0Y9qlx__"